/* eslint-disable spire/export-styles */
import firefoxPrintFix from "@insite/client-framework/Common/Utilities/printFirefox";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import * as React from "react";
import { connect } from "react-redux";

const enum fields {
    textField = "textField",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.textField]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
    session: getSession(state),
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const PageTitle: React.FC<Props> = ({pageTitle, fields, session }: Props) => {
    const isAccountManager = session.userRoles.includes("AccountManager");

    return (
        <>
            {isAccountManager ?
             (
                <Typography variant="h2" as="h1" data-test-selector="PageTitle">
                    {fields.textField || ""}
                </Typography>
            ):(
                <Typography variant="h2" as="h1" data-test-selector="PageTitle">
                {pageTitle || ""}
            </Typography> 
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(PageTitle),
    definition: {
        displayName : "Page Title",
        group: "Common",
        fieldDefinitions:[
            {
                name: fields.textField,
                displayName:"Role Based Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
        ],
        icon: "heading",
    },
};

export default widgetModule;
